const carouselItems = [
  {
    title: '2026暑期档观影指南',
    desc: '这个夏天不容错过的20部大片，从国产巨制到好莱坞视效，大师兄为你精选必看片单，陪你度过炎热暑期。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20night%20atmosphere%20with%20warm%20golden%20hour%20lighting%2C%20outdoor%20cinema%20setup%20with%20fairy%20lights%2C%20cozy%20and%20cinematic%20aesthetic%2C%20nostalgic%20summer%20vibe%2C%20no%20text&width=900&height=500&seq=carousel-01-2026&orientation=landscape',
    tag: '暑期特辑',
  },
  {
    title: '国产科幻电影的黄金时代',
    desc: '从《流浪地球》到《三体》，中国科幻电影正在崛起。深度盘点国产科幻佳作，见证中国电影工业的飞跃进步。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20with%20warm%20orange%20sunset%20lighting%2C%20sleek%20architecture%20and%20hovering%20vehicles%2C%20cinematic%20blockbuster%20aesthetic%2C%20epic%20scale%20with%20atmospheric%20haze%2C%20no%20text&width=900&height=500&seq=carousel-02-2026&orientation=landscape',
    tag: '深度专题',
  },
  {
    title: '王家卫作品全回顾',
    desc: '从《旺角卡门》到《繁花》，跟随大师兄影视回顾王家卫的光影世界。精选经典作品，品味独特美学的魅力。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20street%20scene%20with%20neon%20signs%20and%20warm%20atmospheric%20lighting%2C%20nostalgic%201990s%20cinema%20aesthetic%2C%20rain-slicked%20streets%2C%20film%20noir%20composition%2C%20no%20text&width=900&height=500&seq=carousel-03-2026&orientation=landscape',
    tag: '导演专题',
  },
  {
    title: '高分悬疑剧：烧脑不止',
    desc: '从《隐秘的角落》到《漫长的季节》，国产悬疑剧已成口碑保证。大师兄为你整理必看悬疑剧单，每一部都值得细品。',
    img: 'https://readdy.ai/api/search-image?query=Moody%20mystery%20thriller%20atmosphere%20with%20dramatic%20shadows%20and%20warm%20accent%20lighting%2C%20enigmatic%20urban%20night%20scene%2C%20suspenseful%20cinematography%2C%20noir-inspired%20composition%2C%20no%20text&width=900&height=500&seq=carousel-04-2026&orientation=landscape',
    tag: '剧集推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm md:text-base text-foreground-600">编辑团队精心策划的专题内容，发现更多好片。</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-4 left-4 px-3 py-1 text-xs font-medium rounded-full bg-accent-500 text-white whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-950 mb-3">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}